import getReferential from '../Referential/getReferential';
import { DEFAULT_REFERENTIALS_CLIENT } from '../../config';
import getLocalReferential from '../Referential/getLocalReferential';
import logError from '../Error/postErrorForm';
import getReferentialUpdateDate from '../Referential/getReferentialUpdateDate';

export default async function saveReferentials(refs, token, sourceError, sourceName) {
  let refsToUse = refs;
  if (refsToUse.length === 0) {
    const bodyError = {
      warning: `using default Referentials when calling from ${sourceError} for source ${sourceName}`,
    };
    logError(JSON.stringify(bodyError));
    refsToUse = DEFAULT_REFERENTIALS_CLIENT;
  }
  const costsReferential = refsToUse.map(async (referentialId) => {
    try {
      // check if referential exit en local
      const refUpdateDate = await getReferentialUpdateDate(referentialId, token);
      await getLocalReferential(referentialId, refUpdateDate);
      return referentialId;
    } catch (e) {
      // if not download referential and save
      await getReferential(referentialId, token);
      return referentialId;
    }
  });
  await Promise.all(costsReferential);
}
